function setLiveBalance(balanceInfoId,currentBalance) {
  

  const quantityEl = $(balanceInfoId)
  quantityEl.empty()
  quantityEl.text(`Current Balance:   ${numberWithCommas(currentBalance)}`)

}

$(document).ready(function () {
  const selectBalancePairs = [
    ['#customer-dropdown','#customer-balance-info'],
    ['#transfer-to-select','#transfer-to-balance'],
    ['#tigo-lines-dropdown','#tigo-lines-dropdown-balance'],
    ['#agent-dropdown','#agent-dropdown-balance']
  ]

  for (let i=0; i < selectBalancePairs.length; i++){
    const selectBalancePair = selectBalancePairs[i]
    const dropdownId = selectBalancePair[0]
    const infoDivId = selectBalancePair[1]
    const initialBalance = $(`${dropdownId} option:selected`).data('live-balance')

    if ($(dropdownId).length < 1 ){
      continue
    }

    setLiveBalance(infoDivId,initialBalance)

    $(dropdownId).change(function () {
      const currentBalance = $(`${dropdownId} option:selected`).data('live-balance')
      setLiveBalance(infoDivId,currentBalance)
    })
  }
})